import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import {useGetStorefrontProductCountQuery} from '../../store/endpoints/StorefrontSettingsEndpoints';
import {useGetOrganizationEntitlementsQuery} from "../../store/endpoints/OrganizationsEndpoints";

const StorefrontProductCount = () => {
    const org = useSelector((state: RootState) => state.settings.selectedOrganization);
    const getOrgEntitlements = useGetOrganizationEntitlementsQuery(org ?? '', {skip: !org || org === ''})
    const productCount = useGetStorefrontProductCountQuery();

    return (
        <div>
            {getOrgEntitlements.data?.storefrontLimit && <p>Max Product Count: {getOrgEntitlements.data?.storefrontProductLimit}</p>}
            {productCount.data && <p>Current Product Count: {productCount.data.count}</p>}
        </div>
    );
}

export default StorefrontProductCount;